export default __webpack_public_path__ + "static/media/Delivery-address-amico.e2c1e690.svg";